import {Config} from '../../models';
import {usePromise} from './utilHooks';

let configPromise: Promise<Config> | undefined;
export function getConfig() {
    let urlAppsettings = './appsettings.json';
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
        urlAppsettings = './appsettings.Development.json';
    if (!configPromise) {
        configPromise = fetch(urlAppsettings).then(response => response.json());
    }
    return configPromise;
}

export function useConfig(): Config {
    return usePromise(getConfig());
}
